import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobSkill, deleteJobSkill, fetchJobSkills, updateJobSkill } from "./JobSkillsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobSkillsAsync = createAsyncThunk(
  "jobSkills/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobSkills();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteJobSkillsAsync = createAsyncThunk(
  'jobSkills/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobSkill(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobSkillsAsync = createAsyncThunk(
  'jobSkills/update',
  async ({ uuid, jobSkillData }, { rejectWithValue }) => {
    try {
      const response = await updateJobSkill(uuid, jobSkillData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobSkillsAsync = createAsyncThunk(
  "jobSkills/add",
  async (newJobSkill) => {
    try {
      const data = await addJobSkill(newJobSkill);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      // console.log("errorL :" , error)
      return error
      // return rejectWithValue(error.message);
    }
  }
);

const jobSkillsSlice = createSlice({
  name: "jobSkills",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobSkillsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobSkillsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobSkillsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(addJobSkillsAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobSkillsAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateJobSkillsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobSkillsAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.data) {
          state.data = [];
        }
        state.data = state.data.map((jobTitle) =>
          jobTitle.id === action.payload.id ? action.payload : jobTitle
        );
      })
      .addCase(updateJobSkillsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteJobSkillsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobSkillsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (jobSkill) => jobSkill.id !== action.payload
        );
      })
      .addCase(deleteJobSkillsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectJobSkills = (state) => state.jobSkills.data;

export default jobSkillsSlice.reducer;
